import PigRegistrationSetApi from "@/api/pig-registration/PigRegistrationSetApi";

export default {
  namespaced: true,
  state: {

  },
  mutations: {

  },
  actions: {
    async delete(_, {id}) {
      try {
        await PigRegistrationSetApi.delete(id);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error.response.data);
      }
    },
    async register({dispatch}, form) {
      try {
        await PigRegistrationSetApi.register(form);
        dispatch('NOTIFY_MSG', 'pigRegistration.notification.register',
          { root: true});
        return Promise.resolve();
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async fetchPrefill({dispatch}, {pigStyId}) {
      try {
        const response = await PigRegistrationSetApi.fetchPrefill(pigStyId);
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error.response.data);
      }
    },
  }
}
